<template>
    <div>
        <div class="card card-default">
            <div class="card-header">
                Custom Attribute
            </div>

            <div class="card-body">
                <team-custom-attributes-add :user="user" :team="team" />
            </div>
        </div>

        <div class="card card-default">
            <div class="card-header">
                Custom Attributes
            </div>

            <div class="card-body">
                <team-custom-attributes-list :user="user" :team="team" />
            </div>
        </div>
    </div>
</template>

<script>
import TeamCustomAttributesAdd from './TeamCustomAttributesAdd.vue';
import TeamCustomAttributesList from './TeamCustomAttributesList.vue';

export default {
    props: ['user', 'team'],
    components: {
        TeamCustomAttributesAdd,
        TeamCustomAttributesList,
    },
};
</script>
